/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!**********************!*\
  !*** ./lib/index.js ***!
  \**********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _gixi = __webpack_require__(/*! ./gixi */ 1);
	
	var _gixi2 = _interopRequireDefault(_gixi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof jQuery !== 'undefined' && jQuery) {
	    (function ($) {
	        $.fn.gixi = function () {
	            var sets = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            sets.seed = sets.seed || this.data('gixiseed');
	            sets.size = sets.size || this.data('gixisize') || this.height();
	            sets.size = Math.round(sets.size);
	            sets.color = sets.color || this.data('gixicolor');
	
	            var gxi = new _gixi2.default(sets.size, sets.seed);
	
	            if (sets.color !== 'undefined') gxi.fillStyle = sets.color;
	
	            var data = gxi.getImage();
	
	            if (this.prop('tagName') !== 'IMG') this.css({ 'background-image': 'url(' + data + ')' });else this.attr('src', data);
	        };
	    })(jQuery);
	} else {
	    if (typeof window !== 'undefined') window.GIXI = _gixi2.default;else module.exports = _gixi2.default;
	}
	
	exports.default = _gixi2.default;

/***/ },
/* 1 */
/*!*********************!*\
  !*** ./lib/gixi.js ***!
  \*********************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Color = function () {
	    function Color(_this) {
	        _classCallCheck(this, Color);
	
	        this.r = Math.floor(_this.random() * 200);
	        this.g = Math.floor(_this.random() * 200);
	        this.b = Math.floor(_this.random() * 200);
	        this.t = 1;
	    }
	
	    _createClass(Color, [{
	        key: 'rgba',
	        value: function rgba() {
	            return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.t + ')';
	        }
	    }]);
	
	    return Color;
	}();
	
	/*
	  @param {Number}  width of the image
	  @param {Number}  height of the image
	
	  Properties:
	    fillStyle {css colour}  color of the generated image
	*/
	
	var GIXI = function () {
	    function GIXI() {
	        var w = arguments.length <= 0 || arguments[0] === undefined ? 60 : arguments[0];
	        var seed = arguments.length <= 1 || arguments[1] === undefined ? Math.random() : arguments[1];
	
	        _classCallCheck(this, GIXI);
	
	        this.w = w;
	        this.h = w; //h;
	
	        this.PARTITIONS = 3;
	        this.LESS_SEED = 6;
	
	        this.BASE_SEED = 5;
	        this.SEED_H = this.h / this.BASE_SEED;
	        this.SEED_W = this.w / this.BASE_SEED;
	
	        this.random_seed = 0;
	        seed = seed.toString();
	        for (var i = 0; i < seed.length; i++) {
	            this.random_seed += seed.charCodeAt(i);
	        }
	    }
	
	    _createClass(GIXI, [{
	        key: 'random',
	        value: function random() {
	            this.random_seed = Math.sin(this.random_seed * 34812 + 0.3);
	            return Math.abs(this.random_seed);
	        }
	    }, {
	        key: 'getImage',
	        value: function getImage() {
	            var element = document.createElement('canvas');
	            var imageData = null;
	            element.width = this.w;
	            element.height = this.h;
	
	            if (!element && !element.getContext) throw new Error('Canvas does not supported');
	
	            this.drw = element.getContext('2d');
	            this.drw.fillStyle = this.fillStyle || new Color(this).rgba();
	            this.map(this.grid());
	
	            imageData = element.toDataURL();
	
	            element = null;
	            return imageData;
	        }
	    }, {
	        key: 'draw',
	        value: function draw() {
	            this.drw.fillRect.apply(this.drw, arguments);
	        }
	    }, {
	        key: 'map',
	        value: function map(grid) {
	            for (var y = 0; y < grid.length; y++) {
	                for (var x = 0; x < grid[y].length; x++) {
	
	                    if (grid[y][x] === true) {
	                        this.draw(this.SEED_H * y, this.SEED_W * x, this.SEED_W, this.SEED_H);
	                        if (y < this.PARTITIONS - 1) {
	                            this.draw(this.SEED_H * (this.PARTITIONS + 1 - y), this.SEED_W * x, this.SEED_W, this.SEED_H);
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'grid',
	        value: function grid() {
	            var _this2 = this;
	
	            var makeMap = function makeMap() {
	                var map = [];
	
	                for (var y = 0; y < _this2.PARTITIONS; y++) {
	                    map[y] = [];
	                    for (var x = 0; x < _this2.BASE_SEED; x++) {
	                        map[y][x] = !!Math.floor(_this2.random() * 2);
	                    }
	                }
	
	                map[_this2.PARTITIONS - 1] = map[_this2.PARTITIONS - 1].map(function (i, c) {
	                    return map[_this2.PARTITIONS - 2][c] === i ? false : !!Math.floor(_this2.random() * 2);
	                });
	
	                return {
	                    map: map,
	                    dots: function dots() {
	                        return map.map(function (i) {
	                            return i.reduce(function (p, c) {
	                                return c ? p + c : p;
	                            });
	                        }).reduce(function (p, c) {
	                            return c + p;
	                        });
	                    },
	                    isFilledTop: function isFilledTop() {
	                        return map.map(function (i) {
	                            return i[0];
	                        }).reduce(function (p, c) {
	                            return p || c ? true : false;
	                        });
	                    },
	                    isFilledBottom: function isFilledBottom() {
	                        return map.map(function (i) {
	                            return i[i.length - 1];
	                        }).reduce(function (p, c) {
	                            return p || c ? true : false;
	                        });
	                    }
	                };
	            };
	
	            var result = makeMap();
	
	            while (result.dots() < this.LESS_SEED || !result.isFilledTop() || !result.isFilledBottom()) {
	                result = makeMap();
	            }
	
	            return result.map;
	        }
	    }]);
	
	    return GIXI;
	}();
	
	exports.default = GIXI;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** gixi-min.js
 **/